<template>
  <div class=" tailor">
    <b-navbar class="navbar navbar-dark sticky-top" style="background-color: maroon;">
      <a class="navbar-brand" href="#">Comments <i class="fa fa-comments"></i></a>
      <!-- <b-button v-b-tooltip.hover title="Status" pill variant="outline-light" v-on:click="statusFilterChange()" :disabled="!filteredFeatureList.length">{{statusFilter}}</b-button> -->
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-dropdown v-b-tooltip.hover title="Status" variant="outline-light" :text="statusFilter" size="sm" class="m-2" :disabled="!filteredFeatureList.length" right>
            <b-dropdown-item-button v-on:click="statusFilterChange('Status')">All</b-dropdown-item-button>
            <b-dropdown-item-button v-for="(item, index) in statusFilterSet" :key="index" v-on:click="statusFilterChange(item)">{{item}}</b-dropdown-item-button>
          </b-dropdown>
          <b-dropdown v-b-tooltip.hover title="Discipline" variant="outline-light" :text="disciplineFilter" size="sm" class="m-2" :disabled="!filteredFeatureList.length" right>
            <b-dropdown-item-button v-on:click="disciplineFilterChange('Discipline')">All</b-dropdown-item-button>
            <b-dropdown-item-button v-for="(item, index) in disciplineFilterSet" :key="index" v-on:click="disciplineFilterChange(item)">{{item}}</b-dropdown-item-button>
          </b-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="row">
      <div class="col list-group">
        <template v-if="filteredFeatureList.length">
          <!-- <div v-for="item in filteredFeatureList" :key="item.objectId"> -->
            <a href="#" v-for="item in filteredFeatureList" :key="item.objectId" class="list-group-item list-group-item-action" v-on:click="selectCommentFromList(item.objectId)">
              <div class="row">
                <div class="col-1 ml-3">
                  <i class="fa fa-user"></i>
                </div>
                <div class="col-10">
                  <div class="d-flex w-100 justify-content-between">
                    <p style="margin-bottom: 0.25rem;"><span class="badge badge-secondary badge-pill badge-custom">{{item.objectId}}</span><small> {{item.name}}</small></p>
                    <small class="text-muted">{{getFormattedDate(item.date)}}</small>


                  </div>
                  <div class="d-flex w-100 justify-content-between">
                    <p class="mb-0 font-weight-normal">
                      <small>"{{item.comment.length > 20 ? item.comment.substring(0, 30) + '...' : item.comment}}"</small>
                      <!-- <small><b>Comment Id: {{item.objectId}}</b> "{{commentReplyList.filter(obj => { return obj.objectId == item.objectId })[0].replies[0].reply_details > 0?commentReplyList.filter(obj => { return obj.objectId == item.objectId })[0].replies[0].reply_details: "none"}}"</small> -->
                    </p>
                    <p style="margin-bottom: 0.25rem;">
                      <small class="text-muted">{{item.discipline}}</small>&nbsp;&nbsp;
                      <template v-if="item.approvalStatus == 'Approved'">
                        <span class="badge badge-success badge-pill">{{item.approvalStatus}}</span>
                      </template>
                      <template v-else>
                        <span class="badge badge-danger badge-pill">{{item.approvalStatus}}</span>
                      </template>
                    </p>
                  </div>

                </div>
              </div>
            </a>
          <!-- </div> -->

        </template>
        <template v-else>
          <li class="list-group-item">Loading&hellip;</li>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import { loadModules } from 'esri-loader';
import {baseApiUrl} from "../../config.js"
import axios from "axios"

export default {
  name: 'SideMenu',
  data () {
    return {
      selectedDiscipline: "",
      view: null,
      // webscene: this.$store.state.mapModule.mapWebScene,
      // commentFeatureList: this.$store.state.mapModule.initialComments,
      commentReplyList: this.$store.state.mapModule.commentReplies,
      // currentCommentId: null,
      commentIds: [],
      commentSceneLayer: null,
      highlight: null,
      disciplineFilterSet: ['Road Design','Bridge','Utility','Drainage','Environment','Ecology','Heritage','Geotechnical'],
      disciplineFilter: "Discipline",
      statusFilterSet: ['Approved','Pending'],
      statusFilter: "Status",
      statusFilterCounter: 0,
      dataStatus: "Loading Data..."
    }
  },
  computed: {
    webscene: {
      get() {
        return this.$store.state.mapModule.mapWebScene
      }
    },
    currentCommentId: {
      get() {
        return this.$store.state.mapModule.currentCommentId
      }
    },
    commentFeatureList: {
      get() {
        return this.$store.state.mapModule.initialComments
      }
    },
    filteredFeatureList: {
      get() {
        var finalList = this.commentFeatureList
        if (this.disciplineFilter == "Discipline") {
          finalList =  this.commentFeatureList
        }
        else {
          finalList = this.commentFeatureList.filter(obj=>obj.discipline == this.disciplineFilter)
        }
        if (this.statusFilter != "Status") {
          finalList = finalList.filter(obj=>obj.approvalStatus == this.statusFilter)
        }
        return finalList
      }
    }
    // commentSceneLayer: {
    //   get() {
    //     return this.$store.state.mapModule.commentSceneLayer
    //   }
    // }
  },
  watch: {
    webscene: function() {
      const current = this
      console.log("webscene watch1");

      if (current.webscene) {
        console.log("webscene watch2");
        current.loadCommentList()
      }
    },
    commentFeatureList: function() {
      const current = this
      if (current.commentFeatureList) {
        console.log(window.location.href.split("/"));
        var objectId = window.location.href.split("/")[window.location.href.split("/").length - 1]
        if (!isNaN(parseInt(objectId))) {
          current.selectCommentFromList(objectId)
        }
      }
    }
  },
  methods: {
    loadCommentList: function() {
      const current = this
      current.commentSceneLayer = current.webscene.allLayers.filter(function(item) {
        // return item.title === "Comments3DDevelopment";
        // return item.title === "FiveDocksComments1";
        return item.title === "BaysComments1";
      }).items[0];
      // current.$store.commit("mapModule/saveCommentSceneLayer", current.webscene.allLayers.filter(function(item) {
      //   return item.title === "Comments3DDevelopment";
      // }).items[0])
      current.commentSceneLayer.outFields = ["objectid"];
      const queryParams = current.commentSceneLayer.createQuery()
      // console.log(current.commentSceneLayer.capabilities.queryRelated.supportsOrderBy);
      queryParams.orderByFields = ["objectid"]
      current.commentSceneLayer.queryFeatures(queryParams).then((featureResultItems) => {
        // current.commentFeatureList = featureResultItems.features
        // console.log(featureResultItems);
        // resetting commentFeatureList & state repo
        // current.commentFeatureList = []
        current.commentIds = []
        current.$store.commit("mapModule/resetInitialComments")
        featureResultItems.features.forEach(item => {
          // console.log(item.attributes);
          var featureObject = {}
          featureObject["objectId"] = item.attributes.objectid
          // featureObject["globalId"] = item.attributes.globalid
          featureObject["discipline"] = item.attributes.discipline
          featureObject["priority"] = item.attributes.priority
          featureObject["name"] = item.attributes.name
          featureObject["comment"] = item.attributes.comment
          featureObject["approvalStatus"] = item.attributes.approvalstatus
          featureObject["date"] = item.attributes.date
          featureObject["dueDate"] = item.attributes.duedate

          // current.commentFeatureList.push(featureObject)
          current.commentIds.push(item.attributes.objectid)
          current.$store.commit("mapModule/insertInitialComments", featureObject)

        })
        current.$store.dispatch("mapModule/fetchCommentReplies", {objectIds: current.commentIds})
      })

    },
    // getCommentReplies: function(objectId) {
    //   const current = this
    //     var replies = current.commentReplyList
    //     if(replies.length > 0){
    //       var r1 = replies.filter(obj => { return obj.objectId == objectId })[0]
    //       console.log(current.commentReplyList);
    //       console.log(r1);
    //     }
    //
    //   // const current = this
    //   // var url = baseApiUrl + "fetchReplies"
    //   // var data    = {
    //   //   commentId: objectId
    //   // }
    //   // var config  = {
    //   //   responseType: 'json'
    //   // }
    //   // axios.post(url, data, config).then((result)=>{
    //   //   console.log(objectId);
    //   //   console.log(result.data);
    //   //   var repliesObject = result.data
    //   //   var replyObject = {}
    //   //   replyObject["objectId"] = objectId
    //   //   replyObject["decision"] = repliesObject.decision
    //   //   replyObject["replies"] = repliesObject.replies
    //   //   current.$store.commit("mapModule/insertCommentReplies", replyObject)
    //   // }).catch((error)=> {
    //   //   console.log(error);
    //   // })
    // },
    selectCommentFromList:function(commentId) {
      console.log(commentId);
      // store the commentId and the content of the comment/replies on the store variables
      // selected Comment and selected replies
      const current = this
      if (!current.commentSceneLayer) {
        current.commentSceneLayer = current.webscene.allLayers.filter(function(item) {
          // return item.title === "Comments3DDevelopment";
          // return item.title === "FiveDocksComments1";
          return item.title === "BaysComments1";
        }).items[0];
      }
      if (current.currentCommentId == commentId) {
        current.$store.commit("mapModule/clearAttachments")
        current.toggleFlexContainer()
      }
      else {
        console.log(current.currentCommentId);
        current.closeFlexContainer()
        current.$store.commit("mapModule/clearAttachments")
        current.$store.dispatch("mapModule/setCurrentCommentDetails", commentId)
        // current.getFlexData(commentId)
        console.log(current.currentCommentId);
        current.openFlexContainer()
        const vue = document.getElementById("map").__vue__
        const view = vue.view
        console.log(vue);
        console.log(view);
        loadModules(["esri/tasks/support/Query"],{ css: true })
        .then(([Query]) => {
          console.log(current.commentSceneLayer);
          view.whenLayerView(current.commentSceneLayer).then(function(commentLayerView){
            var queryExtent = new Query({
              objectIds: [commentId],
              returnZ: true,
              returnGeometry: true
            });

            current.commentSceneLayer.queryFeatures(queryExtent)
            .then(function(result) {
              console.log(result);
              if (result.features.length) {
                var center = result.features[0].geometry
                var tilt = view.camera.tilt

                view.goTo({
                  speedFactor: 0.5,
                  zoom: 19,
                  tilt: tilt,
                  center: center
                });
              }
              else {
                current.closeFlexContainer()
              }
                // view.zoom = 5
            });
            if (current.highlight) {
              current.highlight.remove();
            }
            current.highlight = commentLayerView.highlight([commentId]);
          })



        })

      }
      // connect to database, get the data, store to state, then open the flexContainer
    },
    clearTextData:()=>{
      var reply = document.getElementById("newReplyTextArea")
      if (reply) {
        reply.innerHTML = ""
        reply.value = ""
      }
    },
    toggleFlexContainer: function() {
      this.clearTextData()
      var flexContainer = document.getElementById("flexContainer")
      var map = document.getElementById("mapContainer")
      map.classList.toggle("col-9")
      flexContainer.classList.toggle("displayNone")
      map.classList.toggle("col-6")
    },
    closeFlexContainer: function() {
      this.clearTextData()
      var flexContainer = document.getElementById("flexContainer")
      var map = document.getElementById("mapContainer")
      flexContainer.classList.add("displayNone")
      map.classList.remove("col-6")
      map.classList.add("col-9")
    },
    openFlexContainer: function() {
      var flexContainer = document.getElementById("flexContainer")
      var map = document.getElementById("mapContainer")
      map.classList.remove("col-9")
      map.classList.add("col-6")
      flexContainer.classList.remove("displayNone")
    },
    disciplineFilterChange: function(selection) {
      this.disciplineFilter = selection
    },
    statusFilterChange: function(selection) {
      // ++this.statusFilterCounter
      // this.statusFilter = this.statusFilterSet[this.statusFilterCounter%3]
      this.statusFilter = selection
    },
    getFormattedDate: function(dateItem) {
      let date = new Date(dateItem)
      let year = date.getFullYear().toString();
      let month = date.getMonth() + 1;
      month = month.toString().padStart(2, '0');
      let day = date.getDate().toString().padStart(2, '0');
      let hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
      let am_pm = date.getHours() >= 12 ? "pm" : "am";
      hours = hours < 10 ? "0" + hours : hours;
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let time = hours + ":" + minutes + " " + am_pm;
      return year + '-' + month + '-' + day + " " + time;
    },
  },
}
</script>

<style>
  .panel-result {
    cursor: pointer;
    margin: 2px 0;
  }

  .panel-result:hover,
  .panel-result:focus,
  .panel-result.selected {
    background-color: rgba(200, 200, 200, 0.6);
  }
  .tailor {
    height: 93vh;
    max-height: 93vh;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .badge-custom {
    padding-right: 0.45em !important;
    padding-left: 0.45em !important;
    padding: 0.45em 0.45em !important;
  }

</style>
